import { Button } from '@prosolve/common-components-ui';

export default ({ attachment }) => {
  const {
    filename,
    content
  } = attachment || {}

  const onOpen = () => {
    const blob = 
      (content?.type === 'Buffer' && Array.isArray(content.data))
        ? new Blob([new Uint8Array(content.data)], { type: 'application/pdf' })
        : new Blob([content], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank')
  }

  return (
    <Button $colored={true} onClick={onOpen}>{filename}</Button>
  )
};
